import { Phone, Mail, MapPin } from "lucide-react";

const contactItems = [
  { icon: Phone, label: "Phone", value: "7387081978" },
  {
    icon: Mail,
    label: "Email",
    value: "connect@eliteeventzpune.com",
    // Gmail compose (not mailto) so it opens Gmail in the browser directly
    // instead of handing off to whatever mail client the OS has set as default.
    href: "https://mail.google.com/mail/?view=cm&fs=1&to=connect@eliteeventzpune.com",
  },
  { icon: MapPin, label: "Location", value: "Pune, Maharashtra" },
];

export default function ContactUs() {
  return (
    <section id="contact" data-testid="contact-section" className="section">
      <div className="max-w-7xl mx-auto">
        <div className="fade-up glass rounded-[2rem] border border-[var(--ee-border)] p-8 md:p-12 lg:p-16">
          <div className="max-w-3xl mx-auto text-center">
            <div className="eyebrow mb-4">Contact Us</div>
            <h2 className="section-title">
              Let&apos;s connect for your next
              <span className="gold-text-gradient italic"> unforgettable experience</span>
            </h2>
            <p className="mt-4 text-neutral-400 max-w-2xl mx-auto">
              Reach out to us for bookings, collaborations and celebrations.
            </p>
          </div>

          <div className="mt-10 max-w-5xl mx-auto grid gap-4 md:grid-cols-[1fr_1.35fr_1fr]">
            {contactItems.map(({ icon: Icon, label, value, href }) => (
              <div
                key={label}
                className="rounded-2xl border border-[var(--ee-border)] bg-black/20 p-5 text-left"
              >
                <div className="flex items-center gap-3">
                  <div className="w-11 h-11 rounded-xl border border-[var(--ee-border)] flex items-center justify-center shrink-0">
                    <Icon size={18} className="text-[var(--ee-gold)]" />
                  </div>
                  <div className="min-w-0 flex-1">
                    <p className="text-xs uppercase tracking-[0.22em] text-neutral-400">{label}</p>
                    {href ? (
                      <a
                        href={href}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="contact-email-link"
                        className="block text-sm text-neutral-100 mt-0.5 break-words hover:text-[var(--ee-gold)] transition"
                      >
                        {value}
                      </a>
                    ) : (
                      <p className="text-sm text-neutral-100 mt-0.5 break-words">{value}</p>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}